import { Routes, Route, Navigate } from 'react-router-dom'
import { Login } from './components/Login'
import { ProtectedRoute } from './components/ProtectedRoute'
import { DashboardPage as Dashboard } from './features/dashboard/DashboardPage'
import { LicensesPage as Licenses } from './features/licenses/components/LicensesPage'
import { TenantsPage as Tenants } from './features/tenants/components/TenantsPage'
import { ExtensionsPage as Extensions } from './features/extensions/components/ExtensionsPage'
import { DashboardLayout } from './features/dashboard/components/DashboardLayout'
import { BillingPage as Billing } from './features/billing/components/BillingPage'
import { Toaster } from './components/ui/sonner'
import { QueryClientProvider } from './providers/query-client'

function App() {
  return (
    <QueryClientProvider>
      <div className="min-h-screen bg-background">
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<Login />} />

          {/* Protected Routes */}
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Navigate to="/dashboard" replace />
              </ProtectedRoute>
            }
          />
          <Route path="/dashboard" element={<ProtectedRoute><DashboardLayout /></ProtectedRoute>}>
            <Route index element={<Dashboard />} />
            <Route path="licenses" element={<Licenses />} />
            <Route path="tenants" element={<Tenants />} />
            <Route path="extensions" element={<Extensions />} />
            <Route path="billing" element={<Billing />} />
          </Route>

          {/* Catch all - redirect to dashboard or login */}
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>

        {/* Global Toast Container */}
        <Toaster />
      </div>
    </QueryClientProvider>
  )
}

export default App
